import React from "react";
import CardItem from "./CardItem.jsx";
import styles from "../../styles/home/CardSection.module.scss";
import classnames from "classnames";

const CardSection = ({ topLine = "", cardItems, product, backgroundImg}) => {
  if(!product) { 
    return null; 
  }
  const tutorialImgSrc = product === "BB2" ? "https://frontend-assets.buildbox.com/orangetutorials.png" : "https://frontend-assets.buildbox.com/bluetutorials.png"
  return (
    <div
      className={classnames(styles.cardSection, styles[backgroundImg])}
    >
      <h1>{topLine}</h1>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <ul className={styles.items}>
            {cardItems.map((item, i) => (
              <CardItem
                key={i}
                title={item.title}
                img={tutorialImgSrc}
                text={item.description}
                alt={item.alt}
                imgLink={item.imgLink}
                button={item.button}
                buttonCTA={item.buttonCTA}
                {...item}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CardSection;
